import { closePopup } from '../popups'
import { AlchemereThanksModal } from './AlchemereThanksModal'
import { showMessengerPopup } from '../../../components/popups/v1/MessengerPopup/scripts'

export const showAlchemerePopup = (options) => {
  const isLerna = typeof isLernaLanding !== 'undefined' && isLernaLanding // eslint-disable-line

  if (typeof anketologUrl === 'undefined') {
    return null
  }

  // Трекаем открытие анкеты алхимера после оплаты/отправки заявки в форме оплаты
  if (options.type === 'order') {
    window.$analytics?.push('fl-order', window.$paymentData)
  }

  closePopup()

  if (isLerna) {
    showMessengerPopup({
      blockName: options.blockName
    })
  } else {
    // TODO: временный костыль для ленда sales_management_skillbox_x_tochka (нужно будет удалить когда ленд удалят)
    options.type = location.pathname.includes('sales_management_skillbox_x_tochka') ? 'tochka' : options.type

    // NOTICE: https://jira.skillbox.pro/browse/WEBDEV-174335
    const testedCourseSlug = 'product-management-training'
    const isUniqueAnketologTest = location.pathname.includes(testedCourseSlug)

    new AlchemereThanksModal(
      options.type,
      isUniqueAnketologTest ? 'https://ankt.cc/QvIcR0' : anketologUrl, // eslint-disable-line
      { blockName: options.blockName }
    ).init()
  }
}
